// extracted by mini-css-extract-plugin
export default {"dash_search_row":"DashboardSearch_dash_search_row__Is60f","dash_search_label":"DashboardSearch_dash_search_label__7EpBC"};